import React, { useState } from "react";
import { Button } from "reactstrap";
import { useCompanies } from "../../hooks/companies";
import XmlViewerModal from "../autopilot/XmlViewerModal";

// "Ver XML" do detalhe do CT-e (PO1-3365). O XML vem do banco
// (InformacaoRecepcionada), então funciona para CT-e já importado, ao
// contrário da rota do Autopilot, que só lê a Origem do SFTP.
export default function VerXmlCteButton({ summary }) {
  const { empresa } = useCompanies();
  const embarcadorId = empresa && empresa.value;
  const [aberto, setAberto] = useState(false);

  if (!summary || !summary.id) return null;

  const nomeArquivo = `CTe_${summary.numero || summary.id}.xml`;

  return (
    <>
      <Button
        size="sm"
        color="info"
        outline
        onClick={() => setAberto(true)}
        style={{ whiteSpace: "nowrap", marginTop: "0.2rem" }}
      >
        Ver XML
      </Button>
      <XmlViewerModal
        isOpen={aberto}
        onClose={() => setAberto(false)}
        nomeArquivo={nomeArquivo}
        fetchUrl={`/dashboard/auditoria/cte/details/${summary.id}/xml`}
        fetchParams={embarcadorId ? { embarcadorId } : {}}
      />
    </>
  );
}
